import React, { useContext, useEffect, useState } from 'react'
import Restricted from './Restricted'
import Context from '../../setup/context'
import styled from 'styled-components'

const ButtonRed = styled.button`
	background-color: #b51029;
	color: white;
	font-weight: 600;
	border: 0;
	padding: 4px 8px;
	box-shadow: 1px 1px 2px #000;
	margin: 11px auto 7px;
    width: ${props => props.width ? props.width : null};
	&:hover{
		background-color: rgb(219, 22, 51);
	}
	&:active{
		background-color: #b51029;
		box-shadow: 0px 0px 1px #000;
	}
`

const RestrictedContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`

export default function EmployeeAddButton(props) {
    const { details, handleAddToCart, width } = props
    const {
        userInfo, impersonatedCompanyInfo
    } = useContext(Context)

    const [showButton, setShowButton] = useState(true)

    const restrictedCustomerIds = details?.restrictedCustomers?.map(c => c.customerIdP21)
    const customerIdP21 = impersonatedCompanyInfo?.CustomerIdP21

    useEffect(() => {
        if(restrictedCustomerIds?.length > 0 && !restrictedCustomerIds?.includes(customerIdP21)) {
            setShowButton(false)
        } else {
            setShowButton(true)
        }
    }, [customerIdP21, restrictedCustomerIds])

    return showButton ? (
        <ButtonRed onClick={handleAddToCart} width={width}>Add to Cart</ButtonRed>
    ) : (
        <RestrictedContainer>
            <Restricted {...{ userInfo, details }} />
        </RestrictedContainer>
    ) 
}